import { MdDragIndicator, MdEdit } from 'react-icons/md';
import { BiTrash } from 'react-icons/bi';
import { Question } from 'api/questions/types';
import { DraggableProvided } from 'react-beautiful-dnd';

const QUESTION_SNIPPET_MAX = 80;

function truncate(text: string | undefined, max: number = QUESTION_SNIPPET_MAX): string {
  if (!text || typeof text !== 'string') return '';
  return text.length <= max ? text : `${text.slice(0, max).trim()}...`;
}

interface Props {
  question: Question;
  displayIndex: number;
  dragHandleProps?: DraggableProvided['dragHandleProps'];
  onEdit: (q: Question) => void;
  onDelete: () => void;
}

export function ExamQuestionRow({ question, displayIndex, dragHandleProps, onEdit, onDelete }: Props) {
  return (
    <>
      <div
        className="text-sm leading-sm font-medium grid items-center gap-2"
        style={{ gridTemplateColumns: 'auto 1fr auto' }}
      >
        <div className="flex items-center gap-1">
          {dragHandleProps && (
            <div className="cursor-move" {...dragHandleProps}>
              <MdDragIndicator className="w-4 h-4 text-secondary" />
            </div>
          )}
          <span>{displayIndex}.</span>
        </div>
        <p className="text-black">{truncate(question.question)}</p>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex flex-col gap-1.5">
          {question.categories?.map(({ subcategories }) =>
            subcategories.map((subcat) => (
              <div key={subcat} className="badge primary">
                {subcat}
              </div>
            ))
          )}
        </div>
        <div className="flex flex-col gap-1.5">
          <div className="badge danger">{question?.examCategory?.name}</div>
        </div>
        <MdEdit
          className="w-5 h-5 cursor-pointer text-secondary"
          onClick={() => onEdit(question)}
        />
        <BiTrash
          className="w-5 h-5 cursor-pointer text-danger"
          onClick={onDelete}
        />
      </div>
    </>
  );
}
